import styled from 'styled-components';

export const StyledVictimsList = styled.div`
  display: flex;
`;
